<style lang="scss">
	//滚动条的滑块
	.monitorEfficiency::-webkit-scrollbar-thumb {
		background-color: #419FFF;
		border-radius: 2px;
	}
</style>

<template>
	<div ref="container" class="monitorEfficiency"
		style="overflow: auto;height: 100%;position: relative;padding: 20px;">
		<div ref="titleBar" class="titleBar"
			style="display: flex;align-items:center ;padding-bottom: 10px;justify-content: space-between;">
			<div style="display: flex;align-items: center;">
				<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
				<p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
					{{$t('zongtizhibiao')}}
				</p>
				<div style="margin-left: 18px;">
					<p style="font-size: 12px;line-height: 22px;color: #C0C4CC;">
						{{$t('tongjishijian')}}&nbsp{{dayjs.unix($attrs.shift.begin/1000).format('MM-DD HH:mm')}}&nbsp~&nbsp{{dayjs.unix($attrs.shift.end/1000).format('MM-DD HH:mm')}}
					</p>
				</div>
			</div>
			<div>
				<p style="font-size: 12px;line-height: 22px;color: #C0C4CC;">
					{{$t('kaijilvshuoming')}}
				</p>
				<p style="font-size: 12px;line-height: 22px;color: #C0C4CC;">
					{{$t('jiadonglvshuoming')}}
				</p>
			</div>
		</div>
		<div id="monitorEfficiencyAllchart" :style="{'height':chartHeight+'px'}">


		</div>

	</div>

</template>
<script type="text/javascript">
	export default {
		name: 'web_monitor_efficiency_all',
		components: {

		},

		data() {
			return {
				timer: null,
				chart: null,
				option: null,
				chartHeight: 0,
				efficiencies: {},
			};
		},
		created() {
			this.timer = setInterval(() => {
				this.listSum()
			}, 600000)
			this.listSum()
		},

		watch: {
			'$attrs.shift'(newValue, oldValue) {
				if (this.utils.isEqual(newValue, oldValue)) {
					return
				}
				this.listSum()
			},
			'$attrs.orgId'(newValue, oldValue) {
				if (this.utils.isEqual(newValue, oldValue)) {
					return
				}
				this.listSum()
			},

		},
		activated() {
			this.resize()
		},
		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},


		destroyed() {
			if (this.timer) {
				clearInterval(this.timer)
			}
		},
		methods: {
			async listSum() {

				let response = await this.http.get('/web/board/efficiency/index/board/listSum', {
					params: {
						orgId: this.$attrs.orgId
					}
				})

				this.efficiencies.equipmentNames = response.data.map(item => {
					return item.equipmentName
				})
				this.efficiencies.runRates = response.data.map(item => {
					return (item.runRate * 100)
				})
				this.efficiencies.startupRates = response.data.map(item => {
					return (item.startupRate * 100)
				})
				this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 -
					20
				if (!this.chart) {
					setTimeout(() => {
						this.initChart()
					}, 100)
				}else{
					this.option.xAxis.data = this.efficiencies.equipmentNames;
					this.option.series[0].data = this.efficiencies.startupRates;
					this.option.series[1].data = this.efficiencies.runRates;
					this.chart.setOption(this.option)
				}

			},
			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {
					if (!this.$refs.titleBar) {
						return;
					}
					this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 -
						20
					if (!this.chart) {
						return;
					}
					this.chart.getDom().style.height = this.chartHeight + "px";
					this.chart.resize()

				}, 800)
			},
			initChart() {
				this.option = {
					backgroundColor: null,
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							label: {
								formatter: '{value} ' + this.$attrs.shift.shiftName
							},
							// 坐标轴指示器，坐标轴触发有效
							type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
						},
						backgroundColor: 'rgba(0,0,0,0.8)',
						borderWidth: 0,
						textStyle: {
							color: "#C0C4CC",
						},
						valueFormatter: (value) => {
							return value.toFixed(1) + "%"
						}
					},
					grid: {
						left: '0',
						right: '0',
						bottom: '0',
						top: '30',
						containLabel: true,
					},
					legend: {
						left: 'center',
						top: '0%',
						textStyle: {
							color: '#FFFFFF',
							fontSize: 12,
						},
						itemWidth: 15,
						itemHeight: 10,
						itemGap: 25,
					},
					dataZoom: [{
							show: false,
							height: 8,
							xAxisIndex: [0],
							bottom: 0,
							start: 0,
							end: 100,
							handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
							handleSize: '100%',
							handleStyle: {
								color: 'rgba(255, 255, 255,1',
							},
							textStyle: {
								color: "transparent",
								fontSize: 12,
							},
							fillerColor: '#CBCED4',
							borderColor: 'transparent',
							backgroundColor: 'transparent',
							showDataShadow: false,
							brushSelect: false,
						},
						{
							type: 'inside',
							disabled: false,
						},
					],
					xAxis: {
						show: true,
						type: 'category',
						name: '',
						nameLocation: 'end',
						nameTextStyle: {
							fontSize: 12,
						},
						inverse: false,
						splitLine: {
							show: false,
							lineStyle: {
								type: 'dashed',
								color: '#000',
								width: 1,
							},
						},
						axisTick: {
							show: true,
							alignWithLabel: false,
							interval: 'auto',
							inside: false,
							length: 5,
							lineStyle: {
								type: 'solid',
								width: 1,
								color: '#909399',
							},
						},
						axisLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								width: 1,
								color: '#909399',
							},
						},
						axisLabel: {
							margin: 8,
							interval: 'auto',
							rotate: 0,
							fontSize: 12,
							color: '#C0C4CC',
						},
						data: this.efficiencies.equipmentNames,
					},
					yAxis: [{
						show: true,
						type: 'value',
						name: '',
						min: 0,
						nameTextStyle: {
							color: '#909399',
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#909399',
							},
						},
						axisTick: {
							show: false,
						},
						axisLabel: {
							formatter: '{value} %',
							rotate: 0,
							textStyle: {
								color: '#C0C4CC',
							},
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: '#606672',
							},
						},
					}, ],
					series: [{
							name: this.$t('kaijilv'),
							type: 'bar',
							barWidth: '12px',
							itemStyle: {
								normal: {
									color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
											offset: 0,
											color: '#FD9DFF',
										},
										{
											offset: 1,
											color: '#4F32FF',
										},
									]),
									barBorderRadius: 6,
								},
							},
							label: {
								show: false,
								rotate: 0,
								color: '#5C41FF',
								position: 'top',
								fontSize: 12,
								labelFormatter: '{data} %'
							},
							// data: this.efficiencies.runRates,
							data: this.efficiencies.startupRates,
							
						},
						{
							name:  this.$t('jiadonglv'),
							type: 'bar',
							barWidth: '12px',
							itemStyle: {
								normal: {
									color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
											offset: 0,
											color: '#6FE5FF',
										},
										{
											offset: 1,
											color: '#1C70C6',
										},
									]),
									barBorderRadius: 6,
								},
							},
							label: {
								show: false,
								rotate: 0,
								color: '#419FFF',
								position: 'top',
								fontSize: 12,
							},
							// data: this.efficiencies.startupRates,
							data: this.efficiencies.runRates,
							// runRate

						},

					],
				};
				var chartDom = document.getElementById('monitorEfficiencyAllchart');
				this.chart = this.echarts.init(chartDom);
				this.option && this.chart.setOption(this.option);
			}
		}
	};
</script>
